import { axiosMock } from '@api/client';
import { createRandomReaderTask } from '../../mocks/readerTask';
import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from '../apiDictionary';

type FetchReaderTaskMockArgs = {
  clinicalTrialId: string;
  taskId: string;
};

type FetchParentReaderTaskMockArgs = FetchReaderTaskMockArgs & {
  parentTaskId: string;
}

type GenantOpt = 'A' | 'B' | 'C' | 'D';

const getGenantOpt = (): GenantOpt | null => {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('genantOpt')) return null;

  return (params.get('genantOpt') ?? 'A') as GenantOpt;
};

const genantOptions: Record<
  GenantOpt,
  Parameters<typeof createRandomReaderTask>
> = {
  A: ['baseline', 'GENANT_L1_SCORING_FORM'],
  B: ['baseline', 'GENANT_ADJUDICATION_SCORING_FORM'],
  C: ['followup', 'GENANT_L1_SCORING_FORM'],
  D: ['followup', 'GENANT_ADJUDICATION_SCORING_FORM'],
};

const mockReaderTask = (
  url: string,
  ...urlParams: string[]
) => {
  const genantOpt = getGenantOpt();
  if (!genantOpt) return;

  const data = createRandomReaderTask(...genantOptions[genantOpt]);

  axiosMock
    .onGet(prepareUrl(url, urlParams))
    .reply(200, JSON.stringify(data));
};

export const fetchReaderTaskMocks = async (args: FetchReaderTaskMockArgs) => {
  mockReaderTask(API_URL.readerTask, args.taskId);
};

export const fetchParentReaderTaskMocks = async (args: FetchParentReaderTaskMockArgs) => {
  mockReaderTask(API_URL.readerParentTask, args.parentTaskId, args.taskId);
};
